<template>
    <form @submit.prevent="onSubmit">
        <div>
            <InputLabel value="Коментар" />
            <Textarea v-model="form.content" rows="5" />
            <InputError :message="form.errors.content" />
        </div>
        <div class="grid grid-cols-2 gap-5 mt-3" v-if="!$page.props.auth.user">
            <div>
                <InputLabel value="Твоє імʼя" />
                <TextInput v-model="form.name" />
                <InputError :message="form.errors.name" class="mt-2" />
            </div>
            <div>
                <InputLabel value="Телефон" />
                <PhoneInput v-model="form.phone" />
                <InputError :message="form.errors.phone" class="mt-2" />
            </div>
        </div>

        <div class="grid grid-cols-2 gap-5 mt-5">
            <SecondaryButton @click="$emit('closeModal')">Скасувати</SecondaryButton>
            <PrimaryButton color="indigo" :loading="form.processing">Надіслати відповідь</PrimaryButton>
        </div>
    </form>
</template>

<script>
import { defineComponent } from 'vue';
import InputLabel from '@/Components/InputLabel.vue';
import Textarea from '@/Components/Forms/Textarea.vue';
import TextInput from '@/Components/TextInput.vue';
import PhoneInput from '@/Components/PhoneInput.vue';
import SecondaryButton from '@/Components/SecondaryButton.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import InputError from '@/Components/InputError.vue';
import { createToast } from 'mosha-vue-toastify';
import AnswerSent from '@/Components/Toasts/AnswerSent.vue';
import { useForm } from '@inertiajs/vue3';

export default defineComponent({
    components: { InputError, PrimaryButton, SecondaryButton, PhoneInput, TextInput, Textarea, InputLabel },
    props: {
        review: Object,
    },
    data() {
        return {
            form: useForm({
                content: null,
                name: null,
                phone: null,
            })
        };
    },
    methods: {
        onSubmit() {
            this.form.post(this.route('comments.answer', this.review), {
                preserveScroll: true,
                onSuccess: () => {
                    this.$emit('closeModal');

                    createToast(AnswerSent, {
                        position: 'bottom-right',
                        hideProgressBar: true
                    });
                }
            });
        }
    }
});
</script>
